import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import accents from 'remove-accents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCheckDouble, faChartLine } from '@fortawesome/free-solid-svg-icons'

import Info from './Info';
import nextStartDate from '../../utils/nextStartDate';
import Discount from './Discount';
import TopRank from './TopRank';

import './StepTwo.scss';

const styles = {
  hintStyle: {
    color: 'black',
  },
  inputStyle: {
    color: 'black',
    fontWeight: 'bold',
  },
};

class StepTwo extends React.Component {
  state = {
    agreementChecked: false,
  }

  handleCheck = () => {
    this.setState({
      agreementChecked: !this.state.agreementChecked,
    });
  }

  render() {
    const selection = this.props.selectedTrack;

    return (
      <div className="container" id="step-two">
        <div className='row step-two-content'>
          <div className="mx-auto">
            <Discount rate={this.props.rate} />
          </div>

          <div className='col-12 rounded boxshadowSubtle overflowHidden'>
            <div className='row'>
              <div className='col-md-4 col-12 bg-light tuitionInfo'>
                <Info selection={selection} selectedProgram={this.props.selectedProgram} />
              </div>

              <div className='col-md-8 col-12 bg-white'>
                <form className="pb-5">
                  <div className="d-flex flex-column flex-md-row justify-content-center">
                    <div className='d-flex flex-column px-4 pt-5'>
                      <h4>About You</h4>
                      <TextField
                        floatingLabelText="First Name"
                        hintStyle={styles.hintStyle}
                        inputStyle={styles.inputStyle}
                        value={this.props.first_name}
                        onChange={(e) => { this.props.modifyForm({ first_name: accents.remove(e.target.value) }); }}
                        type="text"
                        required="required"
                      />
                      <TextField
                        floatingLabelText="Last Name"
                        hintStyle={styles.hintStyle}
                        inputStyle={styles.inputStyle}
                        value={this.props.last_name}
                        onChange={(e) => { this.props.modifyForm({ last_name: accents.remove(e.target.value) }); }}
                        type="text"
                        required="required"
                      />
                      <TextField
                        floatingLabelText="Email"
                        hintStyle={styles.hintStyle}
                        inputStyle={styles.inputStyle}
                        value={this.props.email}
                        onChange={(e) => { this.props.modifyForm({ email: e.target.value.toLowerCase() }); }}
                        type="email"
                        required="required"
                      />
                    </div>
                    <div className='d-flex flex-column px-4 pt-5'>
                      <h4>Start Date</h4>
                      <RadioButtonGroup
                        name="start_date"
                        onChange={(e) => { this.props.modifyForm({ start_date: e.target.value }); }}
                        valueSelected={this.props.start_date}
                        className='mt-3 mb-3'
                      >
                        <RadioButton
                          value={new nextStartDate().immediately()}
                          label={`Start immediately (Cohort #${new nextStartDate().cohortNumber()} Early Bird)`}
                          type="radio"
                          style={{ display: (new nextStartDate().fromNow() <= -1 & new nextStartDate().late(1).fromNow() >= 5) ? '' : 'none' }}
                        />
                        <RadioButton
                          value={`${new nextStartDate().late(1).pretty()}`}
                          label={`${new nextStartDate().late(1).pretty()} (Cohort #${new nextStartDate().cohortNumber() - 1} Latecomer)`}
                          style={{ display: new nextStartDate().late(1).fromNow() >= 5 ? 'none' : '' }}
                          type="radio"
                        />
                        <RadioButton
                          value={new nextStartDate().pretty()}
                          label={`${new nextStartDate().pretty()} (Cohort #${new nextStartDate().cohortNumber()})`}
                          type="radio"
                          required
                        />
                        <RadioButton
                          value={new nextStartDate().forwardMonths(1).pretty()}
                          label={`${new nextStartDate().forwardMonths(1).pretty()} (Cohort #${new nextStartDate().cohortNumber()+1})`}
                          type="radio"
                        />
                      </RadioButtonGroup>
                    </div>
                  </div>

                  <div className="pt-5 mb-1">
                    <div className="d-flex justify-content-center align-items-center">
                      <Checkbox
                        onCheck={this.handleCheck}
                        checked={this.state.agreementChecked}
                        style={{ display: 'inline-block', width: 'unset' }}
                        iconStyle={{ marginRight: '8px' }}
                      />
                      <div>I have read and I agree to the <a href="/legal/privacy" target="_blank">Privacy Policy</a> and <a href="/legal/terms" target="_blank">Terms of Service</a>.</div>
                    </div>
                  </div>

                  <div className="text-center">
                    <RaisedButton
                      disabled={!this.props.canProceed(3).status || !this.state.agreementChecked}
                      label={this.props.canProceed(3).message}
                      backgroundColor="#1647fb"
                      labelColor="#fff"
                      className="mt-3"
                      labelStyle={{ fontWeight: 'bold' }}
                      onClick={() => { this.props.changeStep(3); }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="mx-auto my-3">
            <TopRank />
          </div>
        </div>
      </div>
    );
  }


}

export default StepTwo;
